<template>
  <div id="smartTextTagsSlider" class="smart-text-tags-slider" refs="smartTextTagsSlider">
    <div class="smart-text-tags-slider-content">
      <el-tag v-for="(tag, indx) in visibleTags" :key="indx"
        :class="[ `el-tag-${'user-db-tags'}`,
        {'_toSeeAllData': (tag.value === '_toSeeAllData')}]">
        <div class="background-color" :style="{'backgroundColor': (tag.backgroundColor ? tag.backgroundColor: '')}"></div>
        <div @click="handleTagItemClick($event, tag, indx)" class="tag-val">
          <span v-if="tag.value === '_toSeeAllData'">{{tag.label}}</span>
          <span v-else-if="tag.showLabel">{{tag.showLabel}}</span>
          <span v-else>{{tag.value}}</span>
        </div>
        <div v-if="enableDeleteTags" @click="handleDeleteTag($event, tag, indx)" class="remove-icon"></div>
        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" @load="checkAllTagsLoaded">
      </el-tag>
    </div>
  </div>
</template>

<script src="./smart-text-tags-slider.js"></script>
<style lang="scss" src="./smart-text-tags-slider.scss"></style>
